import { render, staticRenderFns } from "./ExamSetting.vue?vue&type=template&id=68431160&"
import script from "./ExamSetting.vue?vue&type=script&lang=js&"
export * from "./ExamSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports